












































import { Message, DateRangePicker, formatDate } from 'mycorems-app-shared';
import { DateRange } from 'mycorems-app-shared/src/types';
import { HasTaskMixin } from '@/mixins';
import { ExternalCampaign, ExternalCampaignFilters, QPagination } from '@/types';
import repository from './email-campaign-repository';

interface Data {
  externalCampaigns: ExternalCampaign[],
  selectedCampaigns: ExternalCampaign[],
  selectableCampaignsLimit: number,
  start: string|undefined,
  end: string|undefined,
  pagination: QPagination,
  columns: object[],
}

export default HasTaskMixin.extend({
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      externalCampaigns: [],
      selectedCampaigns: [],
      selectableCampaignsLimit: 20,
      start: undefined,
      end: undefined,
      pagination: {
        page: 1,
        rowsPerPage: 20,
        rowsNumber: 0,
      },
      columns: [
        {
          name: 'name',
          align: 'left',
          label: 'Campaign',
          field: (ec: ExternalCampaign) => ec.name,
        },
        {
          name: 'subject',
          align: 'left',
          label: 'Subject',
          field: (ec: ExternalCampaign) => ec.subject,
        },
        {
          name: 'sentAt',
          align: 'left',
          label: 'Sent',
          field: (ec: ExternalCampaign) => formatDate(ec.sentAt),
        },
      ],
    };
  },
  watch: {
    clientId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  computed: {
    limitReached(): boolean {
      return (this.selectedCampaigns.length === this.selectableCampaignsLimit);
    },
    multipleSelected(): boolean {
      return (this.selectedCampaigns.length > 1);
    },
    paginatedCampaigns(): ExternalCampaign[] {
      if (!this.externalCampaigns.length) return [];
      return this.externalCampaigns.slice(
        (this.pagination.page - 1) * this.pagination.rowsPerPage,
        this.pagination.page * this.pagination.rowsPerPage,
      );
    },
    range(): object {
      return {
        start: this.start,
        end: this.end,
      };
    },
    filters(): ExternalCampaignFilters {
      return {
        start: this.start,
        end: this.end,
      };
    },
  },
  methods: {
    selectedRowsLabel(): string {
      return `${this.selectedCampaigns.length} email campaign${(this.multipleSelected) ? 's' : ''}
       selected.`;
    },
    clear(): void {
      this.start = undefined;
      this.end = undefined;
    },
    selectRange(range: DateRange) {
      this.start = range.start;
      this.end = range.end;
    },
    selectCampaigns(selectedCampaigns: ExternalCampaign[]): void {
      if (selectedCampaigns.length > this.selectableCampaignsLimit) return;
      this.selectedCampaigns = selectedCampaigns;
      this.$emit('selected', selectedCampaigns);
    },
    load(): void {
      this.task = repository.findExternalCampaigns(this.clientId, this.filters);
      this.task.then((externalCampaigns: ExternalCampaign[]) => {
        this.externalCampaigns = externalCampaigns;
        this.pagination.rowsNumber = externalCampaigns.length;
        this.selectedCampaigns = [];
      });
    },
  },
  created(): void {
    this.load();
  },
  components: {
    message: Message,
    'date-range-picker': DateRangePicker,
  },
});
